import { IntegrationField } from '@prismicio/client';
import { IProductsCarousel, ProductsCarouselProps } from './types';
import { IPrismicCollection } from '@monofront/types';

export const mapProductsCarousel = ({
  prismicContent,
  position,
}: {
  prismicContent: ProductsCarouselProps['slice'];
  position: number;
}): IProductsCarousel => {
  const { items, primary } = prismicContent;

  const {
    text_link: textLink,
    collection,
    tracking_id: trackingId,
    card_title: cardTitle,
    card_description: cardDescription,
    card_link_label: cardLinkLabel,
    card_link: cardLink,
    card_background_color: cardBackgroundColor,
    card_illustration: cardIllustration,
    card_tracking_id: cardTrackingId,
  } = primary;

  return {
    ...primary,
    textLink: textLink,
    handle: (collection as IntegrationField<IPrismicCollection>)?.handle || '',
    items,
    trackingId: trackingId,
    cardTitle,
    cardDescription,
    cardLinkLabel,
    cardLink,
    cardBackgroundColor,
    cardIllustration,
    cardTrackingId,
    position,
  };
};
